import React from 'react';
export const BenefitsSection = () => {
  return <section className="py-10 md:py-16 px-6 md:px-10 bg-white" data-id="element-19">
      <div className="max-w-4xl mx-auto" data-id="element-20">
        <h2 className="section-title text-center mb-8 md:mb-12" data-id="element-21">
          Lo que nadie te enseñó y que este método sí te da
        </h2>
        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-22">
          <div className="bg-cream p-6 rounded-lg shadow-md" data-id="element-23">
            <h3 className="text-xl font-bold text-navy mb-4" data-id="element-24">
              El enemigo real: El Dinero Evaporado
            </h3>
            <p className="serif-text" data-id="element-25">
              No es un gasto grande. Son pequeñas fugas invisibles que te dejan
              vacía cada mes.
            </p>
          </div>
          <div className="bg-cream p-6 rounded-lg shadow-md" data-id="element-26">
            <h3 className="text-xl font-bold text-navy mb-4" data-id="element-27">
              La solución: El Mapa Visual de Control Suave™
            </h3>
            <p className="serif-text" data-id="element-28">
              Un sistema que identifica tus fugas sin juzgarte y te devuelve el
              control.
            </p>
          </div>
        </div>
        <div className="bg-navy text-cream p-8 rounded-xl shadow-xl mb-12" data-id="element-29">
          <h3 className="text-xl font-bold mb-6" data-id="element-30">Un sistema que:</h3>
          <ul className="space-y-4 mb-8" data-id="element-31">
            <li className="flex items-start" data-id="element-32">
              <span className="text-gold font-bold mr-2" data-id="element-33">✓</span>
              <span data-id="element-34">Identifica tus fugas sin juzgarte</span>
            </li>
            <li className="flex items-start" data-id="element-35">
              <span className="text-gold font-bold mr-2" data-id="element-36">✓</span>
              <span data-id="element-37">Te devuelve claridad</span>
            </li>
            <li className="flex items-start" data-id="element-38">
              <span className="text-gold font-bold mr-2" data-id="element-39">✓</span>
              <span data-id="element-40">Te ayuda a retener 20–40% más dinero</span>
            </li>
            <li className="flex items-start" data-id="element-41">
              <span className="text-gold font-bold mr-2" data-id="element-42">✓</span>
              <span data-id="element-43">Te permite ayudar sin quedarte vacía</span>
            </li>
            <li className="flex items-start" data-id="element-44">
              <span className="text-gold font-bold mr-2" data-id="element-45">✓</span>
              <span data-id="element-46">Te da tranquilidad mental</span>
            </li>
            <li className="flex items-start" data-id="element-47">
              <span className="text-gold font-bold mr-2" data-id="element-48">✓</span>
              <span data-id="element-49">Requiere solo 10 minutos al mes</span>
            </li>
          </ul>
          <h3 className="text-xl font-bold mb-4" data-id="element-50">Funciona con:</h3>
          <ul className="space-y-2 mb-6" data-id="element-51">
            <li className="flex items-start" data-id="element-52">
              <span className="text-gold font-bold mr-2" data-id="element-53">•</span>
              <span data-id="element-54">tu celular</span>
            </li>
            <li className="flex items-start" data-id="element-55">
              <span className="text-gold font-bold mr-2" data-id="element-56">•</span>
              <span data-id="element-57">un cuaderno</span>
            </li>
            <li className="flex items-start" data-id="element-58">
              <span className="text-gold font-bold mr-2" data-id="element-59">•</span>
              <span data-id="element-60">o el PDF incluido</span>
            </li>
          </ul>
          <p className="text-xl font-semibold" data-id="element-61">Así de simple.</p>
        </div>
      </div>
    </section>;
};